import { Dropdown, Option } from '@risk-first/ui-dropdown';
import { tenants } from '../../data/tenants';
import { useSelectedApp } from '../../hooks/use-selected-app';
import { useSelectedTenant } from '../../hooks/use-selected-tenant';
import { isLocalhost } from '../../utils/is-localhost';

export const TenantChooser: React.FC = () => {
  const selectedApp = useSelectedApp();
  const selectedTenant = useSelectedTenant();

  return (
    <Dropdown
      label={selectedTenant?.name ?? 'Select a tenant'}
      value={selectedTenant?.id}
      variant="select"
      onChange={(selectedTenant: string) => {
        if (isLocalhost()) {
          document.location.search = `?tenant=${selectedTenant}`;
        } else {
          document.location = `https://${selectedTenant}.pfaroe.net/${selectedApp?.id ?? ''}`;
        }
      }}
    >
      {tenants.map((tenant, index) => (
        <Option key={tenant.id} index={index} value={tenant.id}>
          {tenant.name}
        </Option>
      ))}
    </Dropdown>
  );
};
